import apiRequest from '../utils/api-request'
import config from '../common/config'
const baseUrl = config.baseUrl

export class operateLogClient {
	/* 
	 * 操作日志-保存操作日志
	 */
	saveLog(operateLogParam) {
		return apiRequest.post(baseUrl + '/OperateLog/saveLog', operateLogParam)
	}

	/* 
	 * 操作日志-获取操作日志列表
	 */
	search(businessId, businessType) {
		return apiRequest.get(baseUrl + '/OperateLog/search?businessId=' + businessId + '&businessType=' + businessType + '')
	}
}

export class archivesClient {
	/* 
	 * wap端经销商档案-wap根据经销商档案ID查询详情
	 */
	getArchivesById(id) {
		return apiRequest.get(baseUrl + '/app/archives/getArchivesById?id=' + id + '')
	}

	/* 
	 * wap端经销商档案-wap查询经销商档案
	 */
	queryAllArchives(queryParams) {
		return apiRequest.post(baseUrl + '/app/archives/queryAllArchives', queryParams)
	}
}

export class oauth2Client {
	/* 
	 * wap端登录-回调
	 */
	callback(code) {
		return apiRequest.get(baseUrl + '/app/login/oauth2/callback?code=' + code + '')
	}

	/* 
	 * wap端登录-微信授权登录
	 */
	login(state) {
		return apiRequest.get(baseUrl + '/app/login/oauth2/login?state=' + state + '')
	}
	notUserCallback(code) {
		return apiRequest.get(baseUrl + '/app/login/oauth2/notUserCallback?code=' + code + '')
	}

}

export class loginClient {
	/* 
	 * wap端登录-手机号登录接口
	 */
	phoneLogin(appLoginCommand) {
		return apiRequest.post(baseUrl + '/app/login/phoneLogin', appLoginCommand)
	}

	/* 
	 * wap端登录-获取短信验证码
	 */
	sms(appLoginCommand) {
		return apiRequest.post(baseUrl + '/app/login/sms', appLoginCommand)
	}

	/* 
	 * wap端登录-更新openId
	 */
	updateOpenId(createOpenid) {
		return apiRequest.post(baseUrl + '/app/login/updateOpenId', createOpenid)
	}
}

export class questionClient {
	/* 
	 * wap端题库管理-TDM根据问卷ID查询详情
	 */
	findByAssessmentIdTdm(id) {
		return apiRequest.get(baseUrl + '/app/question/findByAssessmentIdTdm?id=' + id + '')
	}

	/* 
	 * wap端题库管理-查询评估列表
	 */
	getAssessmentList(queryParams) {
		return apiRequest.post(baseUrl + '/app/question/getAssessmentList', queryParams)
	}

	/* 
	 * wap端题库管理-根据问卷ID查询详情
	 */
	getAssessmentQuestionById(assessmentType, id, titleNumber, brandType) {
		return apiRequest.get(baseUrl + '/app/question/getAssessmentQuestionById?assessmentType=' + assessmentType + '&id=' + id + '&titleNumber=' + titleNumber + '&brandType=' + brandType)
	}

	/* 
	 * wap端题库管理-根据当前登录信息获取详情-经销商候选客户
	 */
	getUserIdById() {
		return apiRequest.get(baseUrl + '/app/question/getUserIdById')
	}

	/* 
	 * wap端题库管理-查询题库列表
	 */
	queryQuestion(assessmentType, titleNumber) {
		return apiRequest.get(baseUrl + '/app/question/queryQuestion?assessmentType=' + assessmentType + '&titleNumber=' + titleNumber + '')
	}

	/* 
	 * wap端题库管理-新增，修改问卷-答题
	 */
	saveAnswer(createAssessment) {
		return apiRequest.post(baseUrl + '/app/question/saveAnswer', createAssessment)
	}

	/* 
	 * 题库管理-删除题库
	 */
	deleteQuestion(id) {
		return apiRequest.delete(baseUrl + '/question/deleteQuestion?id=' + id + '')
	}

	/* 
	 * 题库管理-导出评估列表
	 */
	exportAssessmentCount(assessmentCountParam) {
		return apiRequest.post(baseUrl + '/question/exportAssessmentCount', assessmentCountParam)
	}

	/* 
	 * 题库管理-根据题库ID获取详情
	 */
	getQuestionById(id) {
		return apiRequest.get(baseUrl + '/question/getQuestionById?id=' + id + '')
	}

	/* 
	 * 题库管理-查询所有
	 */
	queryAllQuestion() {
		return apiRequest.get(baseUrl + '/question/queryAllQuestion')
	}

	/* 
	 * 题库管理-评估统计列表
	 */
	queryAssessmentCount(assessmentCountParam) {
		return apiRequest.post(baseUrl + '/question/queryAssessmentCount', assessmentCountParam)
	}

	/* 
	 * 题库管理-保存题库（id = 0）&&修改题库 和题目
	 */
	saveQuestion(createQuestion) {
		return apiRequest.post(baseUrl + '/question/saveQuestion', createQuestion)
	}

	/* 
	 * 题库管理-查询题库列表
	 */
	searchQuestion(queryParams) {
		return apiRequest.post(baseUrl + '/question/searchQuestion', queryParams)
	}

	getAssessmentListV2(queryParams) {
		let params = ''
		for (let key in queryParams) {
			if (queryParams[key]) {
				params += `${key}=${queryParams[key]}&`
			}
		}
		params = params.substr(0, params.length - 1)
		return apiRequest.get(baseUrl + `/app/question/v2/getAssessmentList?${params}`)
	}

	queryQuestionV2(queryParams) {
		let params = ''
		for (let key in queryParams) {
			if (queryParams[key]) {
				params += `${key}=${queryParams[key]}&`
			}
		}
		params = params.substr(0, params.length - 1)
		return apiRequest.get(baseUrl + `/app/question/v2/queryQuestion?${params}`)
	}

	saveAnswerV2(createAssessment) {
		return apiRequest.post(baseUrl + '/app/question/v2/saveAnswer', createAssessment)
	}

	updateAnswerV2(createAssessment) {
		return apiRequest.post(baseUrl + '/app/question/v2/updateAnswer', createAssessment)
	}
	coverAssessmentV2(queryParams) {
		let params = ''
		for (let key in queryParams) {
			if (queryParams[key]) {
				params += `${key}=${queryParams[key]}&`
			}
		}
		params = params.substr(0, params.length - 1)
		return apiRequest.post(baseUrl + `/app/question/v2/coverAssessment?${params}`)
	}

	queryAnswerBySnV2(queryParams) {
		let params = ''
		for (let key in queryParams) {
			if (queryParams[key]) {
				params += `${key}=${queryParams[key]}&`
			}
		}
		params = params.substr(0, params.length - 1)
		return apiRequest.get(baseUrl + `/app/question/v2/queryAnswerBySn?${params}`)
	}


	apiGetNameCodeList(keyword) {
		return apiRequest.get(baseUrl + `/app/archives/getNameCodeList?keyword=${keyword}`)
	}
	apiGetDealerDetail(pepsiId, openid) {
		return apiRequest.get(baseUrl + `/app/archives/getDealerDetail?pepsiId=${pepsiId}&openid=${openid}`)
	}
}

export class studyCategoryClient {
	/* 
	 * wap端经销商手册-根据分类ID查询课程详情
	 */
	getAppStudyCourseById(fileType, id) {
		return apiRequest.get(baseUrl + '/app/studyCategory/getAppStudyCourseById?fileType=' + fileType + '&id=' + id + '')
	}

	/* 
	 * wap端经销商手册-根据分类ID查询课程获取总数
	 */
	getRcdCourseCount(id) {
		return apiRequest.get(baseUrl + '/app/studyCategory/getRcdCourseCount?id=' + id + '')
	}

	/* 
	 * wap端经销商手册-查询经销商手册列表
	 */
	queryAllStudyCategory() {
		return apiRequest.get(baseUrl + '/app/studyCategory/queryAllStudyCategory')
	}

	/* 
	 * 学习分类管理-删除分类
	 */
	deleteStudyCategory(id) {
		return apiRequest.delete(baseUrl + '/studyCategory/deleteStudyCategory?id=' + id + '')
	}

	/* 
	 * 学习分类管理-查询父级接口列表
	 */
	getParentList() {
		return apiRequest.get(baseUrl + '/studyCategory/getParentList')
	}

	/* 
	 * 学习分类管理-根据分类ID获取详情
	 */
	getStudyCategoryById(id) {
		return apiRequest.get(baseUrl + '/studyCategory/getStudyCategoryById?id=' + id + '')
	}

	/* 
	 * 学习分类管理-根据分类子节点列表
	 */
	getSubclassList() {
		return apiRequest.get(baseUrl + '/studyCategory/getSubclassList')
	}

	/* 
	 * 学习分类管理-保存分类（id = 0）&&修改分类
	 */
	saveStudyCategory(createStudyCategory) {
		return apiRequest.post(baseUrl + '/studyCategory/saveStudyCategory', createStudyCategory)
	}

	/* 
	 * 学习分类管理-查询学习分类列表
	 */
	searchCategory(rcdStudyCategoryParam) {
		return apiRequest.post(baseUrl + '/studyCategory/searchCategory', rcdStudyCategoryParam)
	}
}

export class assessmentQuestionClient {
	/* 
	 * 问卷评估管理-删除组织
	 */
	deleteStudyCourse(id) {
		return apiRequest.delete(baseUrl + '/assessmentQuestion/deleteStudyCourse?id=' + id + '')
	}

	/* 
	 * 问卷评估管理-根据学习课程ID获取详情
	 */
	getStudyCourseById(id) {
		return apiRequest.get(baseUrl + '/assessmentQuestion/getStudyCourseById?id=' + id + '')
	}

	/* 
	 * 问卷评估管理-保存学习课程（id = 0）&&修改学习课程
	 */
	saveStudyCourse(createStudyCourse) {
		return apiRequest.post(baseUrl + '/assessmentQuestion/saveStudyCourse', createStudyCourse)
	}

	/* 
	 * 问卷评估管理-查询学习课程列表
	 */
	searchStudyCourse(queryParams) {
		return apiRequest.post(baseUrl + '/assessmentQuestion/searchStudyCourse', queryParams)
	}
}

export class questionOptionsClient {
	/* 
	 * 选项管理-删除组织
	 */
	deleteStudyCourse(id) {
		return apiRequest.delete(baseUrl + '/questionOptions/deleteStudyCourse?id=' + id + '')
	}

	/* 
	 * 选项管理-根据学习课程ID获取详情
	 */
	getStudyCourseById(id) {
		return apiRequest.get(baseUrl + '/questionOptions/getStudyCourseById?id=' + id + '')
	}

	/* 
	 * 选项管理-保存学习课程（id = 0）&&修改学习课程
	 */
	saveStudyCourse(createStudyCourse) {
		return apiRequest.post(baseUrl + '/questionOptions/saveStudyCourse', createStudyCourse)
	}

	/* 
	 * 选项管理-查询学习课程列表
	 */
	searchStudyCourse(queryParams) {
		return apiRequest.post(baseUrl + '/questionOptions/searchStudyCourse', queryParams)
	}
}

export class rcdArchivesClient {
	/* 
	 * 经销商档案管理-导出经销商
	 */
	exportArchives(queryParams) {
		return apiRequest.post(baseUrl + '/rcdArchives/exportArchives', queryParams)
	}

	/* 
	 * 经销商档案管理-导入经销商
	 */
	importArchives(file) {
		return apiRequest.upload(baseUrl + '/rcdArchives/importArchives', file)
	}

	/* 
	 * 经销商档案管理-查询所有的经销商列表
	 */
	queryArchives() {
		return apiRequest.get(baseUrl + '/rcdArchives/queryArchives')
	}

	/* 
	 * 经销商档案管理-重置评估
	 */
	resetRcdAssociation(ids) {
		return apiRequest.post(baseUrl + '/rcdArchives/resetRcdAssociation', ids)
	}

	/* 
	 * 经销商档案管理-保存档案（id = 0）&&修改档案
	 */
	saveArchives(createArchivesDto) {
		return apiRequest.post(baseUrl + '/rcdArchives/saveArchives', createArchivesDto)
	}

	/* 
	 * 经销商档案管理-查询经销商档案列表
	 */
	searchArchives(queryParams) {
		return apiRequest.post(baseUrl + '/rcdArchives/searchArchives', queryParams)
	}

	/* 
	 * 经销商档案管理-修改状态
	 */
	updateArchivesStatus(updateArchivesDto) {
		return apiRequest.post(baseUrl + '/rcdArchives/updateArchivesStatus', updateArchivesDto)
	}
}

export class redisScheduledClient {
	/* 
	 * redis定时任务-清理全部的redis数据
	 */
	clearAllRedisData() {
		return apiRequest.get(baseUrl + '/redisScheduled/clearAllRedisData')
	}
}

export class clearRedisDataClient {
	/* 
	 * redis定时任务-清理指定key的redis数据
	 */
	/*
	{key}(key) { 
		return apiRequest.get(baseUrl + '/redisScheduled/clearRedisData/{key}?key='+key+'')
	}
	*/
}

export class specialClient {
	/* 
	 * 特殊接口-死循环接口
	 */
	endlessLoop() {
		return apiRequest.get(baseUrl + '/special/endlessLoop')
	}

	/* 
	 * 特殊接口-抛出500错误接口
	 */
	internalServerError() {
		return apiRequest.get(baseUrl + '/special/internalServerError')
	}
}

export class studyCourseClient {
	/* 
	 * 学习课程管理-删除组织
	 */
	deleteStudyCourse(id) {
		return apiRequest.delete(baseUrl + '/studyCourse/deleteStudyCourse?id=' + id + '')
	}

	/* 
	 * 学习课程管理-导出学习统计
	 */
	exportStudyCount(rcdStudyCountParam) {
		return apiRequest.post(baseUrl + '/studyCourse/exportStudyCount', rcdStudyCountParam)
	}

	/* 
	 * 学习课程管理-根据学习课程ID获取详情
	 */
	getStudyCourseById(id) {
		return apiRequest.get(baseUrl + '/studyCourse/getStudyCourseById?id=' + id + '')
	}

	/* 
	 * 学习课程管理-根据课程ID获取课程学习统计
	 */
	getStudyCourseCount(id) {
		return apiRequest.get(baseUrl + '/studyCourse/getStudyCourseCount?id=' + id + '')
	}

	/* 
	 * 学习课程管理-查询学习统计列表
	 */
	queryStudyCount(queryParams) {
		return apiRequest.post(baseUrl + '/studyCourse/queryStudyCount', queryParams)
	}

	/* 
	 * 学习课程管理-新增学习统计
	 */
	saveStudyCount(createStudyCount) {
		return apiRequest.post(baseUrl + '/studyCourse/saveStudyCount', createStudyCount)
	}

	/* 
	 * 学习课程管理-保存学习课程（id = 0）&&修改学习课程
	 */
	saveStudyCourse(createStudyCourse) {
		return apiRequest.post(baseUrl + '/studyCourse/saveStudyCourse', createStudyCourse)
	}

	/* 
	 * 学习课程管理-查询学习课程列表
	 */
	searchStudyCourse(queryParams) {
		return apiRequest.post(baseUrl + '/studyCourse/searchStudyCourse', queryParams)
	}
}

export class dictsClient {
	/* 
	 * 系统管理：数据字典-获取指定Code的字典项
	 */
	getItemsByCode(dictCode) {
		return apiRequest.get(baseUrl + '/system/dicts/getItemsByCode?dictCode=' + dictCode + '')
	}
}

export class systemClient {
	/* 
	 * 用户登录-用户登陆
	 */
	login(loginCommand) {
		return apiRequest.post(baseUrl + '/system/login', loginCommand)
	}

	/* 
	 * 用户登录-退出登陆
	 */
	logout(authorization) {
		return apiRequest.post(baseUrl + '/system/logout?authorization=' + authorization + '')
	}
}

export class orgClient {
	/* 
	 * 组织管理-删除组织
	 */
	deleteOrganization(id) {
		return apiRequest.delete(baseUrl + '/system/org/deleteOrganization?id=' + id + '')
	}

	/* 
	 * 组织管理-根据组织层级查岗位名称
	 */
	findByOrgCode(orgCode) {
		return apiRequest.get(baseUrl + '/system/org/findByOrgCode?orgCode=' + orgCode + '')
	}

	/* 
	 * 组织管理-根据组织ID获取详情
	 */
	getOrganizationById(id) {
		return apiRequest.get(baseUrl + '/system/org/getOrganizationById?id=' + id + '')
	}

	/* 
	 * 组织管理-导入组织
	 */
	importOrganization(file) {
		return apiRequest.upload(baseUrl + '/system/org/importOrganization', file)
	}

	/* 
	 * 组织管理-根据组织层级查组织名称
	 */
	queryByOrgCode(orgCode) {
		return apiRequest.get(baseUrl + '/system/org/queryByOrgCode?orgCode=' + orgCode + '')
	}

	/* 
	 * 组织管理-根据组织ID查询下属组织名称
	 */
	queryByOrgId(id) {
		return apiRequest.get(baseUrl + '/system/org/queryByOrgId?id=' + id + '')
	}

	/* 
	 * 组织管理-保存组织（id = 0）&&修改组织
	 */
	saveOrganization(createOrganization) {
		return apiRequest.post(baseUrl + '/system/org/saveOrganization', createOrganization)
	}

	/* 
	 * 组织管理-查询组织列表
	 */
	searchOrg(queryParams) {
		return apiRequest.post(baseUrl + '/system/org/searchOrg', queryParams)
	}
}

export class roleClient {
	/* 
	 * 角色管理-删除角色
	 */
	deleteRole(id) {
		return apiRequest.delete(baseUrl + '/system/role/deleteRole?id=' + id + '')
	}

	/* 
	 * 角色管理-获取菜单权限集合
	 */
	getMenuTreeList() {
		return apiRequest.get(baseUrl + '/system/role/getMenuTreeList')
	}

	/* 
	 * 角色管理-根据角色ID获取详情
	 */
	getRoleById(id) {
		return apiRequest.get(baseUrl + '/system/role/getRoleById?id=' + id + '')
	}

	/* 
	 * 角色管理-角色分配菜单授权
	 */
	roleMenus(command, id) {
		return apiRequest.put(baseUrl + '/system/role/roleMenus?id=' + id + '', command)
	}

	/* 
	 * 角色管理-保存角色&&修改角色
	 */
	saveRole(createRole) {
		return apiRequest.post(baseUrl + '/system/role/saveRole', createRole)
	}

	/* 
	 * 角色管理-角色列表
	 */
	searchRole(queryParams) {
		return apiRequest.post(baseUrl + '/system/role/searchRole', queryParams)
	}
}

export class userClient {
	/* 
	 * 用户登录-用户信息
	 */
	info() {
		return apiRequest.get(baseUrl + '/system/user/info')
	}
}

export class usersClient {
	/* 
	 * 用户管理-删除用户
	 */
	deleteUser(id) {
		return apiRequest.delete(baseUrl + '/system/users/deleteUser?id=' + id + '')
	}

	/* 
	 * 用户管理-获取用户
	 */
	getUser(id) {
		return apiRequest.get(baseUrl + '/system/users/getUser?id=' + id + '')
	}

	/* 
	 * 用户管理-获取当前用户下的MU
	 */
	getUserByMuList() {
		return apiRequest.get(baseUrl + '/system/users/getUserByMuList')
	}

	/* 
	 * 用户管理-获取当前用户下的省份
	 */
	getUserByProvinceList() {
		return apiRequest.get(baseUrl + '/system/users/getUserByProvinceList')
	}

	/* 
	 * 用户管理-获取选择MU下的RU && 获取选择MU下的AU
	 */
	getUserByRuList(orgLevel, orgName) {
		return apiRequest.get(baseUrl + '/system/users/getUserByRuList?orgLevel=' + orgLevel + '&orgName=' + orgName + '')
	}

	/* 
	 * 用户管理-所属TDM列表
	 */
	getUserByTdm() {
		return apiRequest.get(baseUrl + '/system/users/getUserByTdm')
	}

	/* 
	 * 用户管理-保存用户&&修改用户（userId = 0）
	 */
	saveUser(createUser) {
		return apiRequest.post(baseUrl + '/system/users/saveUser', createUser)
	}

	/* 
	 * 用户管理-用户列表
	 */
	searchUsers(queryParams) {
		return apiRequest.post(baseUrl + '/system/users/searchUsers', queryParams)
	}


}

export class uploadFileClient {
	/* 
	 * 附件上传-获取附件根据ID
	 */
	downloadFile(id) {
		return apiRequest.get(baseUrl + '/uploadFile/downloadFile?id=' + id + '')
	}

	/* 
	 * 附件上传-获取附件
	 */
	downloadSpecialFile(filePath) {
		return apiRequest.get(baseUrl + '/uploadFile/downloadSpecialFile?filePath=' + filePath + '')
	}

	/* 
	 * 附件上传-根据附件ID获取详情
	 */
	getAttachmentById(id) {
		return apiRequest.get(baseUrl + '/uploadFile/getAttachmentById?id=' + id + '')
	}

	/* 
	 * 附件上传-上传文件
	 */
	upload(file) {
		return apiRequest.upload(baseUrl + '/uploadFile/upload', file)
	}
}

export class staticClient {
	/* 
	 * 附件上传-ios下载
	 */
	iosPhoto(imgPath) {
		return apiRequest.get(baseUrl + '/uploadFile/static/iosPhoto?imgPath=' + imgPath + '')
	}

	/* 
	 * 附件上传-新预览图片-下载文件
	 */
	viewPhoto(imgPath) {
		return apiRequest.get(baseUrl + '/uploadFile/static/viewPhoto?imgPath=' + imgPath + '')
	}
}


export class apiRoi {
	apiCover(id, data) {
		return apiRequest.post(`${baseUrl}/app/roi/cover?id=${id}`, data)
	}
	apiDelete(id) {
		return apiRequest.delete(`${baseUrl}/app/roi/delete?id=${id}`)
	}
	apiDetail(id) {
		return apiRequest.get(`${baseUrl}/app/roi/detail?id=${id}`)
	}
	apiList(queryParams) {
		let params = ''
		for (let key in queryParams) {
			if (queryParams[key]) {
				params += `${key}=${queryParams[key]}&`
			}
		}
		params = params.substr(0, params.length - 1)
		return apiRequest.get(`${baseUrl}/app/roi/getList?${params}`)
	}
	apiStore(roi) {
		return apiRequest.post(`${baseUrl}/app/roi/store`, roi)
	}
	apiGetNameCodeList(keyword) {
		return apiRequest.get(`${baseUrl}/app/archives/getNameCodeList?keyword=${keyword}`)
	}
}

export class apiSatisfaction {
	apiCheckAnswerStatus(queryParams) {
		let params = ''
		for (let key in queryParams) {
			if (queryParams[key]) {
				params += `${key}=${queryParams[key]}&`
			}
		}
		params = params.substr(0, params.length - 1)
		return apiRequest.get(`${baseUrl}/app/satisfaction/checkAnswerStatus?${params}`)
	}
	apiCheckAuth() {
		return apiRequest.get(`${baseUrl}/app/satisfaction/checkAuth`)
	}
	apiCover(queryParams) {
		let params = ''
		for (let key in queryParams) {
			if (queryParams[key]) {
				params += `${key}=${queryParams[key]}&`
			}
		}
		params = params.substr(0, params.length - 1)
		return apiRequest.post(`${baseUrl}/app/satisfaction/cover?${params}`)
	}
	apiDetail(soldCode) {
		return apiRequest.get(`${baseUrl}/app/satisfaction/detail?soldCode=${soldCode}`)
	}
	apiList(queryParams) {
		let params = ''
		for (let key in queryParams) {
			if (queryParams[key]) {
				params += `${key}=${queryParams[key]}&`
			}
		}
		params = params.substr(0, params.length - 1)
		return apiRequest.get(`${baseUrl}/app/satisfaction/getList?${params}`)
	}
	apiAnswerDetail(queryParams) {
		let params = ''
		for (let key in queryParams) {
			params += `${key}=${queryParams[key]}&`
		}
		params = params.substr(0, params.length - 1)
		return apiRequest.get(`${baseUrl}/app/satisfaction/getAnswerDetail?${params}`)
	}
	apiQueryAnswer(queryParams) {
		let params = ''
		for (let key in queryParams) {
			params += `${key}=${queryParams[key]}&`
		}
		params = params.substr(0, params.length - 1)
		return apiRequest.get(`${baseUrl}/app/satisfaction/queryAnswer?${params}`)
	}
	apiQueryAnswerBySn(queryParams) {
		let params = ''
		for (let key in queryParams) {
			if (queryParams[key]) {
				params += `${key}=${queryParams[key]}&`
			}
		}
		params = params.substr(0, params.length - 1)
		return apiRequest.get(`${baseUrl}/app/satisfaction/queryAnswerBySn?${params}`)
	}
	apiStore(data) {
		return apiRequest.post(`${baseUrl}/app/satisfaction/store`, data)
	}
	apiUpdate(data) {
		return apiRequest.post(`${baseUrl}/app/satisfaction/update`, data)
	}
	apiTestAuth() {
		return apiRequest.get(`${baseUrl}/app/satisfaction/testAuth`,)
	}
	apiGetNameCodeListAnonymous(keyword, openid) {
		return apiRequest.get(`${baseUrl}/app/satisfaction/getNameCodeListAnonymous?keyword=${keyword}&openid=${openid}`,)
	}
	apiGetFillSetting() {
		return apiRequest.get(`${baseUrl}/app/satisfaction/getFillSetting`,)
	}
	apiGetDealerDetail(soldCode, openid) {
		return apiRequest.get(`${baseUrl}/app/satisfaction/getDealerDetail?soldCode=${soldCode}&openid=${openid}`,)
	}

	apiGetLastFillSoldCode(openid) {
		return apiRequest.get(`${baseUrl}/app/satisfaction/getLastFillSoldCode?openid=${openid}`,)
	}
}

export class apiArchivesManagement {
	getDealerBySoldCode(soldCode) {
		return apiRequest.get(`${baseUrl}/app/dealer/getDealerBySoldCode?soldCode=${soldCode}`)
	}

	queryDealer(data) {
		return apiRequest.post(`${baseUrl}/app/dealer/queryDealer`, data)
	}
}

export default
	{
		apiArchivesManagement: new apiArchivesManagement(),
		operateLogClient: new operateLogClient(),
		archivesClient: new archivesClient(),
		oauth2Client: new oauth2Client(),
		loginClient: new loginClient(),
		questionClient: new questionClient(),
		studyCategoryClient: new studyCategoryClient(),
		assessmentQuestionClient: new assessmentQuestionClient(),
		questionOptionsClient: new questionOptionsClient(),
		rcdArchivesClient: new rcdArchivesClient(),
		redisScheduledClient: new redisScheduledClient(),
		clearRedisDataClient: new clearRedisDataClient(),
		specialClient: new specialClient(),
		studyCourseClient: new studyCourseClient(),
		dictsClient: new dictsClient(),
		systemClient: new systemClient(),
		orgClient: new orgClient(),
		roleClient: new roleClient(),
		userClient: new userClient(),
		usersClient: new usersClient(),
		uploadFileClient: new uploadFileClient(),
		staticClient: new staticClient(),
		apiRoi: new apiRoi(),
		apiSatisfaction: new apiSatisfaction(),
	}